// Kuori · scripts propis (portats de theme.js del tema antic): col·loca el selector de tipus de funda sota el preu.
document.addEventListener("DOMContentLoaded", () => {
  function moveCaseSelectorBelowPrice() {
    const selector = document.querySelector("#caseTypeSelector");
    // Dins la caixa de compra Kuori (kuori-pdp 'buybox') el col·loca assets/kuori-pdp.js
    if (!selector || document.querySelector("[data-kbox]")) return;

    // Busca el bloque del precio (Prestige usa distintas variantes)
    const priceBlock =
      document.querySelector("[data-block-type='price']") ||
      document.querySelector(".price-list") ||
      document.querySelector(".product-info__block--price");

    if (priceBlock && !priceBlock.parentNode.querySelector("#caseTypeSelector")) {
      // Insertar justo después del bloque de precio
      priceBlock.insertAdjacentElement("afterend", selector);
    }

    // Forzar visibilidad y posición
    selector.style.display = "block";
    selector.style.visibility = "visible";
    selector.style.opacity = "1";
    selector.style.position = "relative";
    selector.style.zIndex = 10;
  }

  // Detecta re-render dinámico (Prestige usa AJAX en móvil)
  const target = document.querySelector(".shopify-section--main-product, .product-info__block-list");
  if (target) {
    const observer = new MutationObserver(moveCaseSelectorBelowPrice);
    observer.observe(target, { childList: true, subtree: true });
  }

  // Escucha eventos del tema Prestige
  document.addEventListener("shopify:section:load", moveCaseSelectorBelowPrice);
  document.addEventListener("theme:product:render", moveCaseSelectorBelowPrice);
  document.addEventListener("product:variant:change", moveCaseSelectorBelowPrice);

  // Ejecuta al cargar
  moveCaseSelectorBelowPrice();
});
